import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import ButtonBase from "@material-ui/core/ButtonBase";

// Icons
import kulpaIcon from "../../assets/icons/user-kulpa-i.svg";
// import kulpaIchip from "../../assets/icons/kulpaIchip.svg";
import iconMed from "../../assets/icons/icon-med.svg";
import iconperson from "../../assets/icons/icon-person.svg";
import iconPolice from "../../assets/icons/icon-police.svg";
import iconWitness from "../../assets/icons/icon-witness.svg";

// Config
import colors from "../../config/colors";

// Components
import Text from "../Text";
import Close from "../Close";
import UserTypeButton from "../UserTypeButton/UserTypeButton";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 4, 4),
    display: "flex",
    flexDirection: "column",
    minWidth: 470
  },
  buttonClose: {
    display: "flex",
    marginLeft: "auto",
    padding: theme.spacing(2)
  },
  title: {
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    marginBottom: theme.spacing(3)
  },
  optionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: theme.spacing(3)
  },
  selected: {
    backgroundColor: "#D4F5F9"
  },
  radio: {
    marginRight: theme.spacing(2.5)
  }
}));

const options = [
  {
    userCapacity: "MedicalProfessional",
    icon: iconMed,
    backgroundColor: colors.dodgerBlue
  },
  {
    userCapacity: "PoliceOfficer",
    icon: iconPolice,
    backgroundColor: colors.emergencyHeader
  },
  {
    userCapacity: "Victim",
    icon: iconperson,
    allowAll: true,
    backgroundColor: colors.pictonBlue
  },
  {
    userCapacity: "Witness",
    icon: iconWitness,
    allowAll: true,
    backgroundColor: colors.lilyWhite
  },
  {
    userCapacity: "intelligence",
    icon: kulpaIcon,
    allowAll: true,
    backgroundColor: "#F7F7FF"
    // buttonColor: "#F7F7FF"
    // chipImg: kulpaIchip,
    // borderColor: colors.royalBlue
  }
];

const UserTypeForm = ({ handleNext, handleSelect, onClose, userType }) => {
  const classes = useStyles();

  const onSelect = newValue => {
    handleSelect(newValue);
    handleNext(newValue === "intelligence");
  };

  return (
    <div className={classes.root}>
      <ButtonBase className={classes.buttonClose} onClick={onClose}>
        <Close size={16} color={colors.riverBed} />
      </ButtonBase>
      <Text
        align="left"
        className={classes.title}
        text="createCasePage.userTypeDialog.title"
        type="heading2"
      />
      <Text
        align="left"
        className={classes.subtitle}
        text="createCasePage.userTypeDialog.description"
        type="subtitle3"
      />
      <FormControl component="fieldset">
        <div
          aria-label="userType"
          className={classes.optionContainer}
          name="userType"
        >
          {options.map(
            ({
              allowAll,
              icon,
              userCapacity,
              backgroundColor,
              chipImg,
              buttonColor,
              borderColor
            }) =>
              (allowAll || userType === userCapacity) && (
                <UserTypeButton
                  key={userCapacity}
                  userCapacity={userCapacity}
                  onSelect={onSelect}
                  icon={icon}
                  backgroundColor={backgroundColor}
                  buttonColor={buttonColor}
                  chipImg={chipImg}
                  borderColor={borderColor}
                />
              )
          )}
        </div>
      </FormControl>
    </div>
  );
};

UserTypeForm.propTypes = {
  handleNext: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired
};

export default UserTypeForm;
